// ----------------------------------------------------------------------
// <copyright file="Izenda.ViewerRoute.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  var React = require('react');
  var Route = require('react-router').Route;
  var routeUtils = require('share/utils/Izenda.RouteUtils');

  var ReportPartViewer = require('share/components/views/Izenda.ReportPartViewer');
  var DashboardPartViewer = require('share/components/views/Izenda.DashboardPartViewer');
  var DashboardViewer = require('share/components/views/Izenda.DashboardViewer');
  var ReportBodyViewer = require('share/components/views/Izenda.ReportBodyViewer');
  var viewerRoute = function () {
    var ROUTE = routeUtils.getConfigRoute('Viewer');
    var REPORT_PART_ROUTE = routeUtils.getConfigRoute('Viewer', 'ReportPart');
    var DASHBOARD_PART_ROUTE = routeUtils.getConfigRoute('Viewer', 'DashboardPart');
    var REPORT_BODY_ROUTE = routeUtils.getConfigRoute('Viewer', 'ReportBody');
    var DASHBOARD_ROUTE = routeUtils.getConfigRoute('Viewer', 'Dashboard');

    return (
      <Route
        path={ROUTE.path}>
        <Route
          name={REPORT_PART_ROUTE.name}
          path={REPORT_PART_ROUTE.path}
          component={ReportPartViewer} />
        <Route
          name={DASHBOARD_PART_ROUTE.name}
          path={DASHBOARD_PART_ROUTE.path}
          component={DashboardPartViewer} />
        <Route
          name={REPORT_BODY_ROUTE.name}
          path={REPORT_BODY_ROUTE.path}
          component={ReportBodyViewer} />
        <Route
          name={DASHBOARD_ROUTE.name}
          path={DASHBOARD_ROUTE.path}
          component={DashboardViewer} />
      </Route>
    );
  };

  module.exports = viewerRoute;
}());



// WEBPACK FOOTER //
// ./ui/share/components/views/Izenda.ViewerRoute.jsx